/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegistrationPinResponseDto } from '../../models/registration-pin-response-dto';

export interface BookBookRegistrationIdPinPost$Params {
  bookRegistrationId: string;
}

export function bookBookRegistrationIdPinPost(http: HttpClient, rootUrl: string, params: BookBookRegistrationIdPinPost$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<RegistrationPinResponseDto>> {
  const rb = new RequestBuilder(rootUrl, bookBookRegistrationIdPinPost.PATH, 'post');
  if (params) {
    rb.path('bookRegistrationId', params.bookRegistrationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<RegistrationPinResponseDto>;
    })
  );
}

bookBookRegistrationIdPinPost.PATH = '/Book/{bookRegistrationId}/Pin';
